import {
  ActivitiesCallsFieldNames,
  ActivitiesEmailsFieldNames,
  ActivitiesSubsectionNames,
  ActivitiesTabNames,
  BorrowersSubsectionNames,
  DenialReasonsFieldNames,
  DenialReasonsTabNames,
  FormNames,
  LoanEditorSectionNames,
  NonBorrowerInfoFieldNames,
  NonBorrowersTabNames,
  NotesFieldNames,
  NotesTabNames,
  UnderwritingSubsectionNames,
} from './autoLockForms.constants';
import { getAppFormsTreeFieldId } from './autoLockForms.utils';

const UNDERWRITING_NOTES_AREA = {
  section: LoanEditorSectionNames.UNDERWRITING,
  subsection: UnderwritingSubsectionNames.NOTES,
  tab: NotesTabNames.NOTES,
  form: FormNames.NOTES,
};

const UNDERWRITING_DENIAL_REASONS_AREA = {
  section: LoanEditorSectionNames.UNDERWRITING,
  subsection: UnderwritingSubsectionNames.DENIAL_REASONS,
  tab: DenialReasonsTabNames.DENIAL_REASONS,
  form: FormNames.DENIAL_REASONS,
};

const ACTIVITIES_CALLS_AREA = {
  section: LoanEditorSectionNames.ACTIVITIES,
  subsection: ActivitiesSubsectionNames.ACTIVITIES,
  tab: ActivitiesTabNames.CALLS,
  form: FormNames.ACTIVITIES_CALLS,
};

const ACTIVITIES_EMAILS_AREA = {
  section: LoanEditorSectionNames.ACTIVITIES,
  subsection: ActivitiesSubsectionNames.ACTIVITIES,
  tab: ActivitiesTabNames.EMAILS,
  form: FormNames.ACTIVITIES_EMAILS,
};

const NBE_INFO_AREA = {
  section: LoanEditorSectionNames.BORROWERS,
  subsection: BorrowersSubsectionNames.NON_BORROWERS,
  tab: NonBorrowersTabNames.NBE_INFO,
  form: FormNames.NON_BORROWER_INFO,
};

// appFormsTree ids of the fields whose DOM `name` is not the tree's field name: each such
// field renders `data-field-id={<id>}` so "Go to field" finds it (LEN2-499).
export const MarkedAppFormsTreeFieldId = {
  UNDERWRITING_NOTES: getAppFormsTreeFieldId({
    ...UNDERWRITING_NOTES_AREA,
    field: NotesFieldNames.NOTES,
  }),
  UNDERWRITING_NEW_DENIAL_REASON: getAppFormsTreeFieldId({
    ...UNDERWRITING_DENIAL_REASONS_AREA,
    field: DenialReasonsFieldNames.NEW_DENIAL_REASON,
  }),
  UNDERWRITING_DENIAL_BORROWER_SELECTION: getAppFormsTreeFieldId({
    ...UNDERWRITING_DENIAL_REASONS_AREA,
    field: DenialReasonsFieldNames.BORROWER_SELECTION,
  }),
  ACTIVITIES_CALL_OUTCOME: getAppFormsTreeFieldId({
    ...ACTIVITIES_CALLS_AREA,
    field: ActivitiesCallsFieldNames.CALL_OUTCOME,
  }),
  ACTIVITIES_EMAIL_BODY: getAppFormsTreeFieldId({
    ...ACTIVITIES_EMAILS_AREA,
    field: ActivitiesEmailsFieldNames.BODY,
  }),
  ACTIVITIES_EMAIL_FILES: getAppFormsTreeFieldId({
    ...ACTIVITIES_EMAILS_AREA,
    field: ActivitiesEmailsFieldNames.FILES,
  }),
  NBE_CELL_PHONE_NUMBER: getAppFormsTreeFieldId({
    ...NBE_INFO_AREA,
    field: NonBorrowerInfoFieldNames.CELL_PHONE_NUMBER,
  }),
};
